import React, { useMemo } from "react";

/**
 * Ambient starfield — twinkling stars + occasional diagonal shooting streaks.
 * CSS-driven so it's zero-JS during runtime. Respects prefers-reduced-motion.
 */

const STAR_COUNT = 75;
const SHOOTING_COUNT = 5;

function seededRand(seed) {
  return () => {
    seed = (seed * 9301 + 49297) % 233280;
    return seed / 233280;
  };
}

export default function StarsBg() {
  const stars = useMemo(() => {
    const rnd = seededRand(7);
    return Array.from({ length: STAR_COUNT }, (_, i) => ({
      id: i,
      top: rnd() * 100,
      left: rnd() * 100,
      size: 1.2 + rnd() * 2.8,
      delay: rnd() * 6,
      dur: 2 + rnd() * 4,
      opacity: 0.55 + rnd() * 0.45,
    }));
  }, []);

  const shots = useMemo(() => {
    const rnd = seededRand(21);
    return Array.from({ length: SHOOTING_COUNT }, (_, i) => ({
      id: i,
      top: rnd() * 60,
      left: 10 + rnd() * 60,
      delay: rnd() * 25 + i * 6,
      dur: 4 + rnd() * 3,
    }));
  }, []);

  return (
    <div className="stars-bg" aria-hidden>
      {stars.map(s => (
        <span
          key={s.id}
          className="star"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            width: `${s.size}px`,
            height: `${s.size}px`,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.dur}s`,
            opacity: s.opacity,
          }}
        />
      ))}
      {shots.map(s => (
        <span
          key={`sh-${s.id}`}
          className="shooting"
          style={{
            top: `${s.top}%`,
            left: `${s.left}%`,
            animationDelay: `${s.delay}s`,
            animationDuration: `${s.dur}s`,
          }}
        />
      ))}
    </div>
  );
}
